export default __webpack_public_path__ + "03aed264f8539c570e9bc80ba6b60d92.png";